import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Announcement } from './announcement.model';

const axios = useAxios();

export interface AnnouncementService {
  Fetch: () => Promise<AxiosResponse<Announcement[]>>;
  Find: (id: number) => Promise<AxiosResponse<Announcement>>;
}

const Fetch = (): Promise<AxiosResponse<Announcement[]>> =>
  axios.Get<Announcement[]>('/api/announcements');

const Find = (id: number): Promise<AxiosResponse<Announcement>> =>
  axios.Get<Announcement>(`/api/announcements/${id}`);

export default { Fetch, Find } as AnnouncementService;
